import { render, staticRenderFns } from "./ExerciseEditForm.vue?vue&type=template&id=d8c7672a&"
import script from "./ExerciseEditForm.vue?vue&type=script&lang=js&"
export * from "./ExerciseEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseEditForm.vue?vue&type=style&index=0&id=d8c7672a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports